import { PagingResultsViewModel, FilterSearchingBaseViewModel } from "../../../core/_infrastructure/types/common";

export class TrailblazerPagingResultViewModel extends PagingResultsViewModel {

    public Result: TrailblazerResultViewModel;
}

export class TrailblazerResultViewModel
{
    public Columns: TrailblazerColumnViewModel[];
    public Rows: TrailblazerRowViewModel[];
}

export class TrailblazerColumnViewModel {
    public Field: string;
    public Literal: string;
}


export class TrailblazerRowViewModel
{
    public Values: string[];
}

export class TrailblazerFilterSearchingViewModel  extends FilterSearchingBaseViewModel
{
    public DataView: string;
    public ClauseCollection: string[];
}


